import { render, staticRenderFns } from "./NestedDraggable.vue?vue&type=template&id=f620e890&scoped=true&"
import script from "./NestedDraggable.vue?vue&type=script&lang=js&"
export * from "./NestedDraggable.vue?vue&type=script&lang=js&"
import style0 from "./NestedDraggable.vue?vue&type=style&index=0&id=f620e890&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f620e890",
  null
  
)

export default component.exports